import { render, staticRenderFns } from "./ModalKasKecilCaApproval.vue?vue&type=template&id=34bc6848&"
import script from "./ModalKasKecilCaApproval.vue?vue&type=script&lang=js&"
export * from "./ModalKasKecilCaApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports